import React, { HTMLAttributes } from 'react';
import { useHistory } from 'react-router-dom';

import classNames from 'classnames';

import ArrowLeft from '@ast/magma/components/icon/icons/ArrowLeft';

import { Button } from '@ast/magma/components/button';

import { FullScreenCard } from '@app/common/components/FullscreenCard/FullScreenCard';
import { SectionHeader } from '@app/common/components/SectionHeader/SectionHeader';

import { useTranslation } from '@app/core/i18n';

import styles from './PageLayout.pcss';

export interface PageLayoutProps {
  readonly title?: string;
  readonly backRoute?: string | null;
  readonly onGoBack?: () => void;
}

export const PageLayout: React.FC<PageLayoutProps & HTMLAttributes<HTMLDivElement>> = ({
  title,
  backRoute,
  onGoBack,
  children,
  className,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleBackRoute = () => {
    if (backRoute) {
      history.push(backRoute);
    } else if (onGoBack) {
      onGoBack();
    }
  };

  return (
    <>
      <SectionHeader
        data-stable-name="SectionHeader"
        before={(onGoBack || backRoute) && (
          <Button
            data-stable-name="BackRouteNavigationButton"
            look="icon"
            icon={<ArrowLeft />}
            aria-label={t(
              'page-layout.go-back.aria-label|Accessible text for back route navigation button',
              'Back to previous page',
            )}
            onClick={handleBackRoute}
          />
        )}
      >
        {title}
      </SectionHeader>
      <FullScreenCard
        className={classNames(styles.card, className)}
        hasBorder={false}
      >
        {children}
      </FullScreenCard>
    </>
  );
};
